import * as tslib_1 from "tslib";
import styled from '../styles';
var StyledBackdrop = styled.div.attrs({
    'aria-hidden': true,
    'data-sinoui-test': 'Backdrop',
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: fixed;\n  z-index: -1;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: ", ";\n"], ["\n  position: fixed;\n  z-index: -1;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: ",
    ";\n"])), function (props) {
    return props.visible === false ? 'transparent' : 'rgba(0, 0, 0, 0.5)';
});
export default StyledBackdrop;
var templateObject_1;
//# sourceMappingURL=StyledBackdrop.js.map